<template>
  <v-toolbar
    fixed
    dark
    app
    clipped-left
    height="56"
    class="app-toolbar"
  >
    <v-toolbar-side-icon
      v-model="primaryNavVisible"
      v-if="!simple"
      @click.native.stop="togglePrimaryNav"
    >
      <v-icon>menu</v-icon>
    </v-toolbar-side-icon>

    <nav-logo />

    <v-spacer></v-spacer>
    <app-searchbar :hide-for-xs="simple" />
    <v-btn v-if="isLoggedIn" icon title="User settings" color="blue" @click.native.stop="userNavVisible = !userNavVisible">
      <v-icon>person</v-icon>
    </v-btn>
    <template v-else>
      <v-btn
        :color="simple ? 'white' : 'primary'"
        :flat="simple"
        :href="simple ? `${$options.siteUrls.userSite}/session/new` : '/login'"
        small
      >
        <v-icon
          v-if="simple"
          small
          class="mr-1"
        >lock</v-icon>
        Log in
      </v-btn>
      <v-btn
        v-if="simple"
        color="primary"
        :href="`${$options.siteUrls.userSite}/logins/new`"
        small
      >
        Sign up
      </v-btn>
    </template>
  </v-toolbar>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import AppSearchbar from '@/components/core/AppSearchbar'
  import primaryNavMixin from '@/mixins/primary_nav'
  import NavLogo from '@/components/common/NavLogo'
  import siteUrls from '@/helpers/site_urls'

  export default {
    mixins: [primaryNavMixin],
    props: {
      // For layouts that do not include the list management, and has a focus on new users
      simple: {
        type: Boolean,
        default: false
      }
    },
    siteUrls,
    computed: {
      ...mapGetters('user', ['isLoggedIn']),
      ...mapState('layout', ['showUserNav']),
      userNavVisible: {
        get () {
          return this.showUserNav
        },
        set (val) {
          this.$store.dispatch('layout/setUserNav', val)
        }
      }
    },
    components: {
      AppSearchbar,
      NavLogo
    }
  }
</script>




// WEBPACK FOOTER //
// frontend/src/components/core/AppToolbar.vue